/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  // reports staffer to kw
  var swal;

  swal = require('sweetalert');

  module.exports = function(person_id) {
    return swal({
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Report",
          closeModal: false,
          value: true
        }
      },
      title: 'Report Incorrect Data',
      text: "What is wrong with this information? We'll send it along to our data provider. If you're reporting information about a staffer but clicked on a legislator, make sure to include the staffer's name!",
      content: {
        element: "input",
        attributes: {
          placeholder: 'This person\'s email is incorrect...'
        }
      }
    }).then(function(inputValue) {
      if (inputValue === null) {
        return;
      }
      if (!inputValue) {
        swal('Error', 'You did not submit an explanation. Please explain what is incorrect.', 'error');
        return false;
      }
      return $.ajax({
        url: "/api/person/report_incorrect/",
        data: {
          message: inputValue,
          id: person_id
        },
        type: "POST",
        success: function() {
          return swal("Thanks!", "We've sent it along.", "success");
        }
      });
    });
  };

}).call(globalThis);
